import React from 'react';
import LinksPageView from '../../components/LinksPageView';
import { resolveTheme } from '../../theme';
import { DEFAULT_THEME } from '../../constants';
import '../../styles/foodstation-links.css';
import '../../styles/public-links.css';

/**
 * Página pública (mobile-first) da FoodStation Links — a "bio" do restaurante
 * que o consumidor final acessa. O fundo ao redor do card acompanha o tema.
 */
const PublicLinks = ({ restaurant, products, externalLinks, buttonOrder, theme = DEFAULT_THEME }) => {
  const resolved = resolveTheme(theme);

  return (
    <div className={`fsl-public-shell fsl-public-shell--${resolved.mode}`} style={{ '--v-page-bg': resolved.pageBg }}>
      <div className="fsl-public-bg" aria-hidden />
      <main className="fsl-public-card">
        <LinksPageView
          restaurant={restaurant}
          products={products}
          externalLinks={externalLinks}
          buttonOrder={buttonOrder}
          theme={theme}
          interactive
        />
      </main>
    </div>
  );
};

export default PublicLinks;
